import { createContext } from 'react';

import { noop } from '@/utils/noop';
import { SelectContextState } from '@/ui/Select/types';

export const SelectContext = createContext<SelectContextState>({
  value: '',
  selectRef: null,
  onOptionClick: noop,
  toggleShowOptions: noop,
  setShouldShowOptions: noop,
  shouldShowOptions: false,
});
